<template>
  <div class="feature-item" :class="{'feature-item--selected' : isSelected}" @click="reemitClickEvent">
    <div class="feature-item__title">
      <span>
        {{ title }}
      </span>
    </div>
    <div class="feature-item__subtitle">
      {{ subtitle }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeatureItem',
  data () {
    return {
      contentHeight: undefined
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    reemitClickEvent () {
      this.$emit('click', this.$vnode.child)
    }
  }
}
</script>
<style scoped lang="sass">
@tailwind utilities

.feature-item
  @apply relative inline-block cursor-pointer p-1
  &:hover
    .feature-item
      &__title
        &::after
          transform: scaleX(1)
  @screen md
    @apply w-80
  @screen lg
    @apply w-96
  &__wrapper
    @apply inline-flex flex-col cursor-pointer mb-2
  &__title
    @apply relative inline-flex items-center uppercase text-3xl font-thin whitespace-no-wrap
    &::after
      @apply no-content absolute pin-l bg-pink w-full h-px
      bottom: 3px
      transition: transform .3s
      transform-origin: left center
      transform: scaleX(0)
  &__subtitle
    @apply text-pink
  &--selected
    .feature-item
      &__title
        &::after
          transform: scaleX(1)

.scn--black
  .feature-item
    &__subtitle
      @apply text-white
</style>
